<template>
  <!-- <div id="GoTop" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div> -->
  <div id="to-top">
    <a href="tel:075588321616" id="phone">
      <div class="icon"></div>
      <p class="text-center">0755-88321616</p>
    </a>
    <div id="top" @click="GoTop()"></div>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  }
};
</script>
<style scoped>
/* 回顶部 */
#to-top .icon {
  width: 40px;
  height: 40px;
  background-color: #404040;
}
#to-top .text-center {
  width: 120px;
  height: 40px;
  font-size: 14px;
  padding: 10px 10px 10px 0;
  color: #fff;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
#to-top {
  width: 40px;
  height: 140px;
  position: fixed;
  right: 0px;
  bottom: 0px;
  margin-bottom: -40px;
  z-index: 999999;
  display: flex;
  flex-direction: column;
}
#to-top a {
  text-decoration: none;
}
#phone {
  width: 180px;
  height: 40px;
  background-color: #404040;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  border-radius: 3px;
  overflow: hidden;
}
#phone .icon {
  background: url("../assets/img/totop/phone.png") no-repeat center center;
}
#phone:hover {
  left: -120px;
  background-color: #416eff;
  transition: all 0.5s;
}
#to-top.position-top {
  margin: 0;
  transition: all 0.5s;
}
#toTop {
  display: none;
  text-decoration: none;
  position: fixed;
  bottom: 14px;
  right: 3%;
  overflow: hidden;
  width: 40px;
  height: 40px;
  border: none;
  text-indent: 100%;
  /* background: url("../images/to-top1.png") no-repeat 0px 0px; */
}
#toTopHover {
  width: 40px;
  height: 40px;
  display: block;
  overflow: hidden;
  float: right;
  opacity: 0;
  -moz-opacity: 0;
  filter: alpha(opacity=0);
}
#top {
  position: absolute;
  top: 40px;
  left: 0;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background: url("../assets/img/totop/icon-返回顶部-默认.png") no-repeat center
    center;
}
#top:hover {
  background: url("../assets/img/totop/icon-返回顶部-鼠标经过.png") no-repeat center
    center;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue